module.exports = "<div class=\"row\">\r\n  <div class=\"col-sm-10 col-sm-push-1\">\r\n     <a href=\"#\"><span>FAS Home</span></a> > <a href=\"#\"><span>GAIN Home</span></a> \r\n    </div>\r\n  </div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/layout/breadcrumbs/breadcrumbs.component.html
// module id = ./src/app/layout/breadcrumbs/breadcrumbs.component.html
// module chunks = main